import AddProduct from "../components/AddProduct";

function AddProductPage() {
    return (
        <main>
            <AddProduct />
        </main>
    )
}

export default AddProductPage;